import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkButton', 'status']
  static values = { url: String, termId: String }

  checkFunds(event) {
    event.preventDefault();

    const button = event.currentTarget;

    button.disabled = true;

    fetch(`${this.urlValue}?term_id=${this.termIdValue}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        this.statusTarget.textContent = data.status_text;
        this.statusTarget.className = `status-tag ${data.status_class}`;
        button.classList.add('hidden');
      })
      .catch(error => {
        console.error(error);
        this.statusTarget.className = 'ml-2 font-semibold text-red-600';
      })
      .finally(() => {
        button.disabled = false;
      })
  }
}
